import { useTranslation } from 'react-i18next';

import type { PortfolioGroup } from './accountPortfolio';

export function usePortfolioLabels(): Record<PortfolioGroup, string> {
  const { t } = useTranslation();
  return {
    cash: t('현금'),
    savings: t('저축'),
    investment: t('투자'),
    property: t('부동산·보증금'),
    debt: t('부채'),
    other: t('미분류'),
  };
}
